export default {
  path: 'admins',
  name: 'Administración',
  component: () => import('pages/admin/AdminIndex.vue'),
  children: [
    // Franchises
    {
      path: 'franchises',
      name: 'navigation.admin-franchises.index',
      component: () => import('pages/admin/franchises/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'franchises'
      }
    },
    {
      path: 'franchises/new/',
      name: 'navigation.admin-franchises.new',
      component: () => import('pages/admin/franchises/Franchise.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'franchises'
      }
    },
    {
      path: 'franchises/edit/:franchise_id',
      name: 'navigation.admin-franchises.edit',
      component: () => import('pages/admin/franchises/Franchise.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'franchises'
      }
    },
    // Locations
    {
      path: 'locations',
      name: 'navigation.admin-locations.index',
      component: () => import('pages/admin/locations/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'locations'
      }
    },
    {
      path: 'locations/groups/',
      name: 'navigation.admin-locations.groups',
      component: () => import('pages/admin/locations/Groups.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'locations'
      }
    },
    {
      path: 'locations/edit/:location_id',
      name: 'navigation.admin-locations.edit',
      component: () => import('pages/admin/locations/Location.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'locations'
      }
    },
    {
      path: 'locations/new/',
      name: 'navigation.admin-locations.new',
      component: () => import('pages/admin/locations/Location.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'locations'
      }
    },
    // Roles
    {
      path: 'roles',
      name: 'navigation.admin-roles.index',
      component: () => import('pages/admin/roles/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'roles'
      }
    },
    {
      path: 'roles/edit/:role_id',
      name: 'navigation.admin-roles.edit',
      component: () => import('pages/admin/roles/Role.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'roles'
      }
    },
    {
      path: 'roles/new/',
      name: 'navigation.admin-roles.new',
      component: () => import('pages/admin/roles/Role.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'roles'
      }
    },
    {
      path: 'roles/tree/',
      name: 'navigation.admin-roles.tree',
      component: () => import('pages/admin/roles/Hierarchy.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'roles'
      }
    },
    {
      path: 'roles/tree/:franchise_id',
      name: 'navigation.admin-roles.tree_configuration',
      component: () => import('pages/admin/roles/HierarchyConfiguration.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'roles'
      }
    },
    // Users
    {
      path: 'users',
      name: 'navigation.admin-users.index',
      component: () => import('pages/admin/users/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'users'
      }
    },
    {
      path: 'users',
      name: 'navigation.manager-users.index',
      component: () => import('pages/admin/users/Index.vue'),
      meta: {
        isPasswordManager: true,
        requiredPermissions: 'users'
      }
    },
    {
      path: 'users/edit/:user_id',
      name: 'navigation.admin-users.edit',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'users'
      }
    },
    {
      path: 'users/edit/:user_id',
      name: 'navigation.manager-users.edit',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isPasswordManager: true,
        requiredPermissions: 'users'
      }
    },
    {
      path: 'users/new/',
      name: 'navigation.admin-users.new',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'users'
      }
    },
    // Forms
    {
      path: 'forms',
      name: 'navigation.admin-forms.index',
      component: () => import('pages/admin/forms/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    {
      path: 'forms/edit/:form_id',
      name: 'navigation.admin-forms.edit',
      component: () => import('pages/admin/forms/Form.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    {
      path: 'forms/new/',
      name: 'navigation.admin-forms.new',
      component: () => import('pages/admin/forms/Form.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    {
      path: 'forms/build/:form_id/:source_form_id',
      name: 'navigation.admin-forms.build-cloned',
      component: () => import('pages/admin/forms/FormBuild.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    {
      path: 'forms/build/:form_id/',
      name: 'navigation.admin-forms.build',
      component: () => import('pages/admin/forms/FormBuild.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    {
      path: 'forms/preview/:form_id',
      name: 'navigation.admin-forms.preview',
      component: () => import('pages/admin/forms/FormPreview.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    {
      path: 'forms/test/:form_id',
      name: 'navigation.admin-forms.test',
      component: () => import('pages/admin/forms/FormTest.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'forms'
      }
    },
    // Catalogs
    {
      path: 'catalogs',
      name: 'navigation.admin-catalogs.index',
      component: () => import('pages/admin/catalogs/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'catalogs'
      }
    },
    {
      path: 'catalogs/edit/:catalog_id',
      name: 'navigation.admin-catalogs.edit',
      component: () => import('pages/admin/catalogs/Catalog.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'catalogs'
      }
    }, {
      path: 'catalogs/new',
      name: 'navigation.admin-catalogs.new',
      component: () => import('pages/admin/catalogs/Catalog.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'catalogs'
      }
    },
    // Sprints
    {
      path: 'sprints',
      name: 'navigation.admin-sprints.index',
      component: () => import('pages/admin/sprints/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'sprints'
      }
    },
    // Campaigns
    {
      path: 'campaigns',
      name: 'navigation.admin-campaigns.index',
      component: () => import('pages/admin/campaigns/Index.vue'),
      meta: {
        isSupervisor: true,
        requiredPermissions: 'campaigns'
      }
    },
    {
      path: 'campaigns/new',
      name: 'navigation.admin-campaigns.new',
      component: () => import('pages/admin/campaigns/Campaign.vue'),
      meta: {
        isSupervisor: true,
        requiredPermissions: 'campaigns'
      }
    },
    {
      path: 'campaigns/edit/:campaign_id',
      name: 'navigation.admin-campaigns.edit',
      component: () => import('pages/admin/campaigns/Campaign.vue'),
      meta: {
        isSupervisor: true,
        requiredPermissions: 'campaigns'
      }
    },
    // Mailing
    {
      path: 'mailing',
      name: 'navigation.mailing.index',
      component: () => import('pages/admin/mailing/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'mailing'
      }
    },
    // Notifications
    {
      path: 'notifications',
      name: 'navigation.admin-notifications-center.index',
      component: () => import('pages/admin/notificationsCenter/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'notifications'
      }
    },
    // Notices
    {
      path: 'notices',
      name: 'navigation.admin-notices-center.index',
      component: () => import('pages/admin/notices/Index.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'notices'
      }
    },
    // Surveys
    {
      path: 'surveys',
      name: 'navigation.admin-surveys.index',
      component: () => import('pages/admin/satisfactionSurveys/SurveyIndex.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'surveys'
      }
    },
    {
      path: 'surveys/:survey_id/edit',
      name: 'navigation.survey.edit',
      component: () => import('pages/admin/satisfactionSurveys/Edit.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'surveys'
      }
    },
    {
      path: 'surveys/:survey_id',
      name: 'navigation.survey.view',
      component: () => import('pages/admin/satisfactionSurveys/View.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'surveys'
      }
    },
    {
      path: 'surveys/:survey_id/link',
      name: 'navigation.survey.link',
      component: () => import('pages/admin/satisfactionSurveys/Link.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'surveys'
      }
    },
    // Configuration
    {
      path: 'general-settings',
      name: 'navigation.admin-settings',
      component: () => import('pages/admin/settings/IndexSettings.vue'),
      meta: {
        isAdmin: true,
        requiredPermissions: 'general-settings'
      }
    },
    {
      path: 'aria',
      name: 'navigation.aria.index',
      component: () => import('pages/Aria.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'aria/new',
      name: 'navigation.aria.new',
      component: () => import('pages/admin/aria/Document.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'aria/edit/:file_id',
      name: 'navigation.aria.edit',
      component: () => import('pages/admin/aria/Document.vue'),
      meta: {
        isAdmin: true
      }
    }
  ]
}
